import React, { useEffect, useState } from "react";
import EmailVerify from "./Components/Dashbord/EmailVerify";
import { oneKlicks } from "../../SDK/oneclick";
import { getuserdata } from "../../services/apiService";
import { toast } from "react-toastify";
import { convertCurrency } from "../../Uitiles/ConvterCurrency";
import { useAuth } from "../../context/AuthContext";

const WithdrawalPopup = ({ isOpen, onClose, totalBalance, onSubmit, usercarncy }) => {
    const [amount, setAmount] = useState("");
    const [error, setError] = useState("");
    const [localDoctorId, setLocalDoctorId] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
            setError("Please enter a valid amount");
            return;
        }
        if (parseFloat(amount) > totalBalance) {
            setError("Amount cannot exceed total balance");
            return;
        }
        onSubmit(parseFloat(amount));
        setAmount("");
        setError("");
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div className="modal-content" style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                width: '400px',
                maxWidth: '90%'
            }}>
                <h3 style={{ marginBottom: '20px' }}>Withdraw Funds</h3>
                <form onSubmit={handleSubmit}>
                    <div className="form-group" style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px' }}>Available Balance: {totalBalance} {usercarncy}</label>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Enter amount to withdraw"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '8px',
                                borderRadius: '4px',
                                border: '1px solid #ddd'
                            }}
                        />
                        {error && <p style={{ color: 'red', marginTop: '5px' }}>{error}</p>}
                    </div>
                    <div >
                        <div className="row" style={{ display: 'flex', flexDirection: 'row-reverse', marginRight: '0px', gap: '10px' }}>
                            <button
                                type="submit"
                                className="dc-btn"
                                style={{
                                    minWidth: '140px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontWeight: 500
                                }}
                            >
                                Confirm Withdrawal
                            </button>
                            <button
                                type="button"
                                onClick={onClose}
                                className="dc-btn"
                                style={{
                                    minWidth: '100px',
                                    backgroundColor: '#f5f5f5',
                                    color: '#222',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontWeight: 500
                                }}
                            >
                                Cancel
                            </button>

                        </div>

                    </div>
                </form>
            </div>
        </div>
    );
};

const YourPayouts = () => {
    const { userData } = useAuth();
    const [totalEarning, setTotalEarning] = useState(0);
    const [totalWithdrawals, setTotalWithdrawals] = useState(0);
    const [totalBalance, setTotalBalance] = useState(0);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [payoutHistory, setPayoutHistory] = useState([]);
    const [usercarncy, setUsercurrency] = useState('₹');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (userData?.id) {
            fetchPayoutData();
        }
    }, [userData?.id]);



    const fetchPayoutData = async () => {
        if (!userData?.id) return;
        try {
            setLoading(true);

            // 1. Fetch Payout History
            const historyResponse = await oneKlicks.read("", "payout_history", { doctor_id: userData.id }, "id DESC", "", "", "");
            const history = historyResponse.success ? (historyResponse.data || []) : [];
            setPayoutHistory(history);

            // Calculate already requested/completed payouts
            const withdrawn = history.reduce((sum, p) => {
                const amt = parseFloat(p.amount) || 0;
                // Count all except rejected? Usually pending strings also count as reserved.
                if (p.status !== 'rejected') return sum + amt;
                return sum;
            }, 0);
            setTotalWithdrawals(withdrawn);

            // 2. Fetch Appointments for Earning (Revenue)
            const appointmentsRes = await oneKlicks.read("", "appointments", { doctor_id: userData.id }, "id DESC", "", "", "");
            let revenue = 0;
            if (appointmentsRes?.success && appointmentsRes?.data) {
                appointmentsRes.data.forEach(apt => {
                    const amt = Number(apt.amount || apt.display_amount) || 0;
                    if (amt > 0) revenue += amt;
                });
            }
            setTotalEarning(revenue);

            // 3. Final Balance
            const currentBalance = revenue - withdrawn;
            setTotalBalance(currentBalance > 0 ? currentBalance : 0);

        } catch (error) {
            console.error("Error fetching payout data:", error);
            toast.error("Failed to update financial records");
        } finally {
            setLoading(false);
        }
    };

    const handleWithdrawal = async (amount) => {
        try {
            const data = {
                doctor_id: userData.id,
                amount,
                status: 'pending',
                created_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
            };

            const response = await oneKlicks.create("", "payout_history", data);
            if (response.success) {
                // Also create a notification for the Admin
                // We'll look for an admin user or just create a generic admin-targeted notification
                await oneKlicks.create("", "notifications", {
                    user_id: 1, // Defaulting to 1 for superadmin, or you can fetch admin user
                    title: "New Payout Request",
                    message: `Doctor ${userData.display_name || 'User'} has requested a withdrawal of ${usercarncy}${amount}`,
                    type: "payout_request",
                    status: "unread",
                    created_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
                });

                toast.success("Withdrawal request submitted to admin for approval");
                setIsPopupOpen(false);
                fetchPayoutData();
            } else {
                toast.error(response.message || "Failed to submit withdrawal request");
            }
        } catch (error) {
            console.error("Error submitting withdrawal:", error);
            toast.error("An error occurred. Please try again.");
        }
    };

    if (loading && payoutHistory.length === 0) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px', flexDirection: 'column', gap: '15px' }}>
                <div className="spinner-border text-primary" role="status"></div>
                <p style={{ color: '#666' }}>Fetching your payout records...</p>
            </div>
        );
    }

    return (
        <div className="dc-tabscontent">
            <div className="dc-securityhold" id="dc-payouts">
                <div className="dc-tabsinfo dc-email-settings">
                    <div className="dc-tabscontenttitle" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h3>Your Payouts</h3>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '25px' }}>
                            <div style={{ textAlign: 'center', borderRight: '1px solid #eee', paddingRight: '20px' }}>
                                <p style={{ margin: 0, fontSize: '12px', color: '#666', textTransform: 'uppercase' }}>Total Earned</p>
                                <h5 style={{ margin: 0, color: '#333', fontWeight: '700' }}>{usercarncy}{totalEarning.toFixed(2)}</h5>
                            </div>
                            <div style={{ textAlign: 'center', borderRight: '1px solid #eee', paddingRight: '20px' }}>
                                <p style={{ margin: 0, fontSize: '12px', color: '#666', textTransform: 'uppercase' }}>Withdrawn</p>
                                <h5 style={{ margin: 0, color: '#ef4444', fontWeight: '700' }}>{usercarncy}{totalWithdrawals.toFixed(2)}</h5>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <p style={{ margin: 0, fontSize: '12px', color: '#666', textTransform: 'uppercase' }}>Available</p>
                                <h4 style={{ margin: 0, color: '#28a745', fontWeight: '800' }}>{usercarncy}{totalBalance.toFixed(2)}</h4>
                            </div>
                            <button
                                onClick={() => setIsPopupOpen(true)}
                                className="dc-btn"
                                style={{
                                    padding: '10px 24px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontWeight: '700',
                                    boxShadow: '0 4px 12px rgba(40, 167, 69, 0.2)'
                                }}
                            >
                                Withdraw
                            </button>
                        </div>
                    </div>
                    <div className="dc-settingscontent">
                        <div className="dc-description">
                            <p>Your payout history</p>
                        </div>
                        <div className="table-responsive">
                            <table className="table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f8f9fa' }}>
                                        <th style={{ padding: '12px', textAlign: 'left' }}>Date</th>
                                        <th style={{ padding: '12px', textAlign: 'left' }}>Amount</th>
                                        <th style={{ padding: '12px', textAlign: 'left' }}>Status</th>
                                        <th style={{ padding: '12px', textAlign: 'left' }}>Reference</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {payoutHistory.map((payout, index) => (
                                        <tr key={index} style={{ borderBottom: '1px solid #dee2e6' }}>
                                            <td style={{ padding: '15px 12px', fontSize: '13px' }}>
                                                {new Date(payout.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                                            </td>
                                            <td style={{ padding: '15px 12px', fontWeight: '700', color: '#333' }}>{usercarncy}{parseFloat(payout.amount).toFixed(2)}</td>
                                            <td style={{ padding: '15px 12px' }}>
                                                <span style={{
                                                    padding: '4px 12px',
                                                    borderRadius: '20px',
                                                    fontSize: '11px',
                                                    fontWeight: '700',
                                                    textTransform: 'uppercase',
                                                    backgroundColor:
                                                        payout.status === 'completed' ? '#dcfce7' :
                                                            payout.status === 'pending' ? '#fef9c3' :
                                                                '#fee2e2',
                                                    color:
                                                        payout.status === 'completed' ? '#166534' :
                                                            payout.status === 'pending' ? '#854d0e' :
                                                                '#991b1b',
                                                }}>
                                                    {payout.status}
                                                </span>
                                            </td>
                                            <td style={{ padding: '15px 12px', color: '#666', fontSize: '12px' }}>{payout.reference_id || '---'}</td>
                                        </tr>
                                    ))}
                                    {payoutHistory.length === 0 && (
                                        <tr>
                                            <td colSpan="4" style={{ padding: '12px', textAlign: 'center' }}>
                                                No payout history available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <WithdrawalPopup
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
                totalBalance={totalBalance}
                onSubmit={handleWithdrawal}
                usercarncy={usercarncy}
            />
        </div>
    );
};

const PayoutsSettings = () => {
    const [userdata, setUserdata] = useState({});
    const [selectedPayoutMethod, setSelectedPayoutMethod] = useState("");
    const [activeTab, setActiveTab] = useState("settings"); // Add state for active tab
    const [payoutDetails, setPayoutDetails] = useState({
        paypal_email: "",
        bank_account_name: "",
        bank_account_number: "",
        bank_name: "",
        bank_routing_number: "",
        bank_iban: "",
        bank_bic_swift: "",
        payout_method: ""
    });

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        console.log("userData", userData);
        if (userData) {
            setUserdata(userData);
        }
        fetchPayoutDetails();
    }, []);

    const fetchPayoutDetails = async () => {
        try {
            const tableSchema = "";
            const tableName = "payout_settings";
            const conditions = { doctor_id: await getuserdata('id') };
            const response = await oneKlicks.read(tableSchema, tableName, conditions);
            console.log("fetchPayoutDetails response", response);
            if (response.success) {
                const payoutDetailsObj = JSON.parse(response.data[0].payout_details);
                setPayoutDetails({
                    paypal_email: payoutDetailsObj.paypal_email,
                    bank_account_name: payoutDetailsObj.bank_account_name,
                    bank_account_number: payoutDetailsObj.bank_account_number,
                    bank_name: payoutDetailsObj.bank_name,
                    bank_routing_number: payoutDetailsObj.bank_routing_number,
                    bank_iban: payoutDetailsObj.bank_iban,
                    bank_bic_swift: payoutDetailsObj.bank_bic_swift,
                    payout_method: response.data[0].payout_method
                });
                setSelectedPayoutMethod(response.data[0].payout_method);
            }
        } catch (error) {
            console.error("Error fetching payout details:", error);
            toast.error("Failed to fetch payout details");
        }
    };

    const getPayoutSettings = async () => {
        console.log("userdata", userdata);
        const doctor_id = await getuserdata('full');
        setUserdata(doctor_id);

        const tableSchema = "";
        const tableName = "payout_settings";
        const conditions = { doctor_id: userdata.id };
        const response = await oneKlicks.read(tableSchema, tableName, conditions);
        console.log("response", response);
    }

    const handlePayoutMethodChange = (method) => {
        setSelectedPayoutMethod(method);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPayoutDetails(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Here you can add the logic to save the payout settings
        console.log("Payout settings:", { method: selectedPayoutMethod, details: payoutDetails });
        const tableSchema = "";
        const tableName = "payout_settings";
        const data = {
            payout_method: selectedPayoutMethod,
            payout_details: JSON.stringify(payoutDetails),
            doctor_id: await getuserdata('id')
        };
        const condition = {
            doctor_id: await getuserdata('id')
        };
        const update = await oneKlicks.update(tableSchema, tableName, data, condition);
        console.log("update", update);
        if (update.success === true) {
            toast.success('Payout settings updated successfully');
        } else {
            toast.error(update.message || 'Failed to update payout settings');
        }
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
            {userdata.activation_key == null && <EmailVerify />}

            <section className="dc-haslayout dc-dbsectionspace">
                <div className="row">
                    <div className="dc-haslayout dc-account-settings">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 pull-lg-3 float-left">
                            <div className="dc-dashboardbox dc-dashboardtabsholder dc-accountsettingholder dc-payout-holder">
                                <div className="dc-dashboardtabs">
                                    <ul className="dc-tabstitle nav navbar-nav">
                                        <li className="nav-item">
                                            <a
                                                className={activeTab === "settings" ? "active" : ""}
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabChange("settings");
                                                }}
                                            >
                                                Payouts Settings
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={activeTab === "payouts" ? "active" : ""}
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabChange("payouts");
                                                }}
                                            >
                                                Your Payouts
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                {activeTab === "settings" ? (
                                    <div className="dc-tabscontent">
                                        <div className="dc-securityhold" id="dc-account">
                                            <div className="dc-tabsinfo dc-email-settings">
                                                <div className="dc-tabscontenttitle">
                                                    <h3>Payouts Settings</h3>
                                                </div>
                                                <div className="dc-settingscontent">
                                                    <div className="dc-description">
                                                        <p>All the earning will be sent to below selected payout method</p>
                                                    </div>
                                                    <div className="dc-formtheme dc-userform payout-holder">
                                                        <form className="dc-payout-settings" onSubmit={handleSubmit}>
                                                            <fieldset>
                                                                <div className="dc-checkboxholder">
                                                                    <span className="dc-radio">
                                                                        <input
                                                                            id="payrols-paypal"
                                                                            type="radio"
                                                                            name="payout_settings[type]"
                                                                            value="paypal"
                                                                            checked={selectedPayoutMethod === "paypal"}
                                                                            onChange={() => handlePayoutMethodChange("paypal")}
                                                                        />
                                                                        <label htmlFor="payrols-paypal">
                                                                            <figure className="dc-userlistingimg">
                                                                                <img src="//css.meddylist.com//wp-content/themes/doctreat/images/payouts/paypal.png" alt="Paypal" />
                                                                            </figure>
                                                                        </label>
                                                                    </span>
                                                                </div>
                                                                {selectedPayoutMethod === "paypal" && (
                                                                    <div className="fields-wrapper dc-haslayout dc-description">
                                                                        <div className="dc-payouts-settings-details">
                                                                            <div className="dc-description">
                                                                                <p>You need to add your PayPal ID below in the text field. For more about <a target="_blank" href="https://www.paypal.com/"> PayPal </a> | <a target="_blank" href="https://www.paypal.com/signup/">Create an account</a></p>
                                                                            </div>
                                                                            <div className="form-group form-group-half toolip-wrapo">
                                                                                <input
                                                                                    type="text"
                                                                                    name="paypal_email"
                                                                                    id="paypal_email-payrols"
                                                                                    className="form-control"
                                                                                    placeholder="Add PayPal Email Address"
                                                                                    value={payoutDetails.paypal_email}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                            </div>
                                                                            <div className="form-group dc-btnarea">
                                                                                <button type="submit" className="dc-btn dc-payrols-settingss" data-id="paypal">Submit</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </fieldset>
                                                            <fieldset>
                                                                <div className="dc-checkboxholder">
                                                                    <span className="dc-radio">
                                                                        <input
                                                                            id="payrols-bacs"
                                                                            type="radio"
                                                                            name="payout_settings[type]"
                                                                            value="bacs"
                                                                            checked={selectedPayoutMethod === "bacs"}
                                                                            onChange={() => handlePayoutMethodChange("bacs")}
                                                                        />
                                                                        <label htmlFor="payrols-bacs">
                                                                            <figure className="dc-userlistingimg">
                                                                                <img src="//css.meddylist.com//wp-content/themes/doctreat/images/payouts/bank.png" alt="Direct Bank Transfer (BACS)" />
                                                                            </figure>
                                                                        </label>
                                                                    </span>
                                                                </div>
                                                                {selectedPayoutMethod === "bacs" && (
                                                                    <div className="fields-wrapper dc-haslayout dc-description">
                                                                        <div className="dc-payouts-settings-details">
                                                                            <div className="dc-description">
                                                                                <p>Please add all required settings for the bank transfer.</p>
                                                                            </div>
                                                                            <div className="form-group form-group-half toolip-wrapo">
                                                                                <input
                                                                                    type="text"
                                                                                    name="bank_account_name"
                                                                                    id="bank_account_name-payrols"
                                                                                    className="form-control"
                                                                                    placeholder="Bank Account Name"
                                                                                    value={payoutDetails.bank_account_name}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                            </div>
                                                                            <div className="form-group form-group-half toolip-wrapo">
                                                                                <input
                                                                                    type="text"
                                                                                    name="bank_account_number"
                                                                                    id="bank_account_number-payrols"
                                                                                    className="form-control"
                                                                                    placeholder="Bank Account Number"
                                                                                    value={payoutDetails.bank_account_number}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                            </div>
                                                                            <div className="form-group form-group-half toolip-wrapo">
                                                                                <input
                                                                                    type="text"
                                                                                    name="bank_name"
                                                                                    id="bank_name-payrols"
                                                                                    className="form-control"
                                                                                    placeholder="Bank Name"
                                                                                    value={payoutDetails.bank_name}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                            </div>
                                                                            <div className="form-group form-group-half toolip-wrapo">
                                                                                <input
                                                                                    type="text"
                                                                                    name="bank_routing_number"
                                                                                    id="bank_routing_number-payrols"
                                                                                    className="form-control"
                                                                                    placeholder="Bank Routing Number"
                                                                                    value={payoutDetails.bank_routing_number}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                            </div>
                                                                            <div className="form-group form-group-half toolip-wrapo">
                                                                                <input
                                                                                    type="text"
                                                                                    name="bank_iban"
                                                                                    id="bank_iban-payrols"
                                                                                    className="form-control"
                                                                                    placeholder="Bank IBAN"
                                                                                    value={payoutDetails.bank_iban}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                            </div>
                                                                            <div className="form-group form-group-half toolip-wrapo">
                                                                                <input
                                                                                    type="text"
                                                                                    name="bank_bic_swift"
                                                                                    id="bank_bic_swift-payrols"
                                                                                    className="form-control"
                                                                                    placeholder="Bank BIC/SWIFT"
                                                                                    value={payoutDetails.bank_bic_swift}
                                                                                    onChange={handleInputChange}
                                                                                />
                                                                            </div>
                                                                            <div className="form-group dc-btnarea">
                                                                                <button type="submit" className="dc-btn dc-payrols-settingss" data-id="bacs">Submit</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </fieldset>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <YourPayouts />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PayoutsSettings;
